import { useEffect, useRef } from 'react'
import { useOrg } from '../contexts/OrgContext'
import { useAssessment } from '../contexts/AssessmentContext'
import { supabase } from '../shared/lib/supabase'

export function useDemoPlan() {
  const { currentOrg } = useOrg()
  const { clients, loading } = useAssessment()
  const isDemoOrg = currentOrg?.plan_tier === 'demo'
  const provisionedRef = useRef(null)

  // Auto-provision Rider Bank [DEMO] if missing from a demo org
  useEffect(() => {
    if (!isDemoOrg || !currentOrg?.id) return
    if (loading) return
    if (provisionedRef.current === currentOrg.id) return

    const hasRiderBank = clients.some(c => c.name === 'Rider Bank [DEMO]')
    if (hasRiderBank) {
      provisionedRef.current = currentOrg.id
      return
    }

    // Mark as provisioned immediately to prevent duplicate calls (React Strict Mode, re-renders)
    provisionedRef.current = currentOrg.id

    const provision = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (!session) return

        const res = await fetch(`/api/organizations/${currentOrg.id}/provision-demo`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        })
        const data = await res.json()
        if (data.provisioned) {
          window.location.reload()
        }
      } catch (err) {
        console.error('[useDemoPlan] Provision error:', err)
        provisionedRef.current = null // Allow retry on error
      }
    }

    provision()
  }, [isDemoOrg, currentOrg?.id, clients, loading])

  return {
    isDemoOrg,
    clientCap: isDemoOrg ? 2 : (currentOrg?.client_cap ?? Infinity),
    canDownloadPolicies: !isDemoOrg,
    demoMessage: (feature) =>
      `${feature} is not available in Demo Mode. To see an example in .docx or .pdf format, email support@sidewalksecurity.com`
  }
}
